import { Component, Inject, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import {
    takeUntilDestroy,
    TakeUntilDestroy,
} from '../../common/take-until-destroy.decorator';
import { ScorecardDataService } from '../core/data.service';
import { Widget, WidgetType } from '../core/template-definition.model';
import { TranslationKeyMap } from '../scorecard.i18n';
import { CMPS_SCORECARD_WIDGET } from '../scorecard.metadata';
import { Rank } from '../scorecard.model';

@Component({
    selector: 'cmps-scorecard-ranks-widget',
    templateUrl: './ranks-widget.component.html',
})
@TakeUntilDestroy()
export class ScRanksWidgetComponent implements OnDestroy {
    /** @private */ _i18n = TranslationKeyMap;
    /** @private */ _collapsed: boolean;
    /** @private */ _ranks: Rank[];

    /** @private */ get _isLoadingData(): Observable<boolean> {
        return this._loadingData.asObservable();
    }

    private readonly _loadingData: BehaviorSubject<boolean>;

    public headerColour: string;
    public headerTextColour: string;

    constructor(
        private readonly _dataService: ScorecardDataService,
        @Inject(CMPS_SCORECARD_WIDGET) /** @private */ public _widget: Widget,
    ) {
        this.headerColour = _widget.headerColour;
        this.headerTextColour = _widget.headerTextColour;
        this._loadingData = new BehaviorSubject<boolean>(false);
    }

    ngOnInit(): void {
        this._dataService
            .observableForWidgetType<Rank[]>(WidgetType.RANKINGS_GRID)
            .pipe(
                tap((data) => {
                    this._ranks = data || [];
                }),
                takeUntilDestroy(this),
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        //
    }
}
